export const chatsTab = [
  {
    id: 1,
    name: "HOME",
    path: "/",
    selected: true,
  },
  {
    id: 2,
    name: "SERVICES",
    path: "/services",
    selected: false,
  },
  {
    id: 3,
    name: "ABOUT US",
    path: "/about-us",
    selected: false,
  },
  {
    id: 4,
    name: "CONTACT US",
    path: "/contact-us",
    selected: false,
  },
];


export const feature1 = require("../assets/images/f1.webp");
export const feature2 = require("../assets/images/f2.webp");
export const feature3 = require("../assets/images/f3.webp");
export const feature4 = require("../assets/images/f4.webp");
export const collection1 = require("../assets/images/c1.webp");
export const collection2 = require("../assets/images/c2.webp");
export const collection3 = require("../assets/images/c3.webp");

export const aboutus1 = require("../assets/images/about1.webp");
export const aboutus2 = require("../assets/images/about2.webp");
export const services1 = require("../assets/images/services1.webp");
export const services2 = require("../assets/images/services2.webp");
export const services3 = require("../assets/images/services3.webp");
export const services4 = require("../assets/images/services4.webp");
export const services5 = require("../assets/images/services5.webp");
export const services6 = require("../assets/images/services6.webp");
export const services7 = require("../assets/images/services7.webp");
export const services8 = require("../assets/images/services8.webp");
